export default __webpack_public_path__ + "static/media/eigenheim_icons_document.fcecf61f.svg";